import { MMButton } from '@components'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useHistory } from 'react-router-dom'

import styles from './CountryRestrictedPane.module.scss'

const CountryRestrictedPane = () => {
  const history = useHistory()

  const handleClick = () => {
    history.push(paths.dashboard())
  }

  return (
    <div className={styles['country-restricted-wrapper']}>
      <div className='warning-body'>
        <h1>{tr('FRONTEND.WARNING.TITLE', 'Warning!')}</h1>
        <h2>{tr('FRONTEND.WARNING.COUNTRY_RESTRICTED', 'Operation not allowed for this country or recipient.')}</h2>
      </div>

      <div className='warning-footer'>
        <MMButton
          type='button'
          size='large'
          variant='alternative'
          caption={tr('FRONTEND.WARNING.BACK_BUTTON', 'Back to Overview')}
          onClick={handleClick}
          data-test='button-back'
          fullWidth
        />
      </div>
    </div>
  )
}

export default CountryRestrictedPane
